export default __webpack_public_path__ + "images/assets/27900b85a404cd9746da2c9e28d44b1e.svg";